import { SecureRoute } from '@okta/okta-react';
import React, { FC } from 'react';
import { Switch, useRouteMatch } from 'react-router';
import { PartnerTeamMembers } from 'components/pages/partner';
import { PartnerDetail } from 'components/pages/partner/detail';
import { RoutePaths } from 'constant';
import { AllSettings } from '../settings';

export const PartnerRoute: FC = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <SecureRoute
        path={`${path}${RoutePaths.partnerInformation}`}
        component={PartnerDetail}
        exact
      />
      <SecureRoute
        path={`${path}${RoutePaths.partnerTeamMembers}`}
        component={PartnerTeamMembers}
        exact
      />
      <SecureRoute path={path} component={AllSettings} />
    </Switch>
  );
};
